import { graphql } from 'react-relay';
export const EndOfPageRecommendationQuery = graphql`
	query EndOfPageRecommendationQuery(
		$type: String!
		$id: ID!
		$exp: String!
		$key: ID!
		$keyString: String!
	) {
		space(key: $keyString) {
			id
		}
		getRecommendedPages(entityType: $type, entityId: $id, experience: $exp) {
			recommendedPages {
				content {
					id
					title
					type
					subType
					creatorId
					links {
						webui
					}
					history {
						ownedBy {
							displayName
						}
					}
					space {
						id
						key
						name
					}
					emoji: properties(key: "emoji-title-published") {
						nodes {
							id
							key
							value
						}
					}
				}
				strategy
			}
			status {
				userCanToggle
				isEnabled
			}
		}
		getRecommendedPagesSpaceStatus(entityId: $key) {
			recommendedPagesEnabled
			defaultBehavior
		}
	}
`;
